import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { scrollToSection } from "../hooks/useLenis";

const AUDIENCES = [
    "Businesses",
    "Entrepreneurs",
    "Ministries & Churches",
    "Coaches & Consultants",
    "Authors & Speakers",
    "Podcasts & Creators",
    "Nonprofits",
    "Photographers & Artists",
    "Events & Conferences",
    "Personal Brands",
];

export const Audience = () => (
    <section id="audience" className="relative py-24 md:py-36" data-testid="audience-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <Eyebrow>Who We Build For</Eyebrow>
            </Reveal>
            <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
                <Reveal delay={0.1}>
                    <h2 className="font-display text-4xl font-extrabold tracking-tight text-[#0A0F1D] sm:text-5xl lg:text-6xl">
                        PEOPLE WITH<br />SOMETHING TO <span className="text-electric-grad">SAY.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="max-w-sm text-sm leading-relaxed text-slate-600 sm:text-base">
                        If you have a vision worth sharing, you deserve a website worthy of it.
                    </p>
                </Reveal>
            </div>

            <div className="mt-14">
                {AUDIENCES.map((a, i) => (
                    <motion.button
                        key={a}
                        data-testid={`audience-item-${i}`}
                        onClick={() => scrollToSection("contact")}
                        className="group flex w-full items-center gap-5 border-t border-[#0A0F1D]/10 py-5 text-left transition-[padding] duration-500 hover:pl-4 md:py-6"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.6, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                        aria-label={`${a} — start your website`}
                    >
                        <span className="font-mono text-[10px] tracking-[0.3em] text-slate-400 transition-colors duration-300 group-hover:text-[#0066FF]">
                            {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="flex-1 font-display text-2xl font-bold tracking-tight text-slate-500 transition-colors duration-300 group-hover:text-[#0A0F1D] sm:text-3xl md:text-4xl">
                            {a}
                        </span>
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#0A0F1D]/10 text-slate-500 transition-[background-color,border-color,color,transform] duration-300 group-hover:rotate-45 group-hover:border-[#0066FF]/60 group-hover:bg-[#0066FF]/10 group-hover:text-[#0066FF]">
                            <ArrowUpRight className="h-4 w-4" />
                        </span>
                    </motion.button>
                ))}
                <div className="border-t border-[#0A0F1D]/10" />
            </div>
        </div>
    </section>
);
